import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=6b3b34c0&scoped=true"
import script from "./serviceOrder.vue?vue&type=script&lang=js"
export * from "./serviceOrder.vue?vue&type=script&lang=js"
import style0 from "./serviceOrder.vue?vue&type=style&index=0&id=6b3b34c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b34c0",
  null
  
)

export default component.exports